import { gql } from '@provision/graphql-client';

export const CONVERSATION_TRIAGE_RUN_TIMELINE_FIELDS = gql`
  fragment ConversationTriageRunTimelineFields on ConversationTriageRun {
    id
    conversationTriageRunId
    conversationId
    partnerId
    userInstructions
    createdAt
    conversationTriageRunSteps {
      id
      conversationTriageRunStepId
      status
      createdAt
      conversationTriageRunActions {
        id
        conversationTriageRunActionId
        status
        visibility
        display
        payload
        appliedAt
        appliedBy
        applyError
        createdAt
      }
    }
  }
`;
